import axios from "@lib/axios";

export async function getFeaturedPlan(locale) {
  try {
    const res = await axios.get("plan", {
      headers: { Language: locale },
    });

    return res.data.data;
  } catch (err) {
    return {};
  }
}
